module.exports = __webpack_public_path__ + "static/media/upvote.46349d37.gif";